import { Controller } from "stimulus";
import 'select2';
import 'select2/dist/css/select2';
import GuardianService from "../entrypoints/src/admin/services/guardian-service";
import EnrollmentService from "../entrypoints/src/admin/services/enrollment-service";
import Swal from "sweetalert2";
import { isEmpty } from "lodash";
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";

export default class extends Controller {
  static targets = ['addDependentModal', 'selectEnrollment', 'selectKinship'];
  static values = {
    guardianId: Number
  };

  async connect() {
    let data = await this.enrollments();

    $(this.selectEnrollmentTarget).select2({
      language: "pt-BR",
      placeholder: 'Nome do Responsável',
      data: data,
      tags: true,
      debug: true,
      allowClear: false,
      multiple: false,
      minimumInputLength: 3,
      closeOnSelect: true,
      dropdownParent: $(this.addDependentModalTarget),
      matcher: this.matchCustom,
      escapeMarkup: (markup) => markup,
    });

    // Start with no enrollment selected so the placeholder shows instead of
    // auto-selecting the first item from the data array.
    $(this.selectEnrollmentTarget).val(null).trigger('change');

    // Inside a Bootstrap modal the search field doesn't get focus automatically;
    // focus it on open so the user can type the search right away.
    $(this.selectEnrollmentTarget).on('select2:open', () => {
      requestAnimationFrame(() => {
        const searchField = this.addDependentModalTarget.querySelector('.select2-search__field');
        if (searchField) searchField.focus();
      });
    });
  }

  async addDependent(ev) {
    if (!this.isDependentValid())
      return;

    try {
      AjaxLoader.show();
      await GuardianService.addDependent(this.guardianIdValue, { enrollmentId: this.selectEnrollmentTarget.value, kinshipDegreeId: this.selectKinshipTarget.value });
      AjaxLoader.hide();

      Swal.fire({
        html: `Dependente adicionado com sucesso!`,
        showClass: { backdrop: 'swal2-noanimation', popup: '', },
        hideClass: { popup: '' },
        customClass: {
          cancelButton: 'btn btn-gray-primary',
          confirmButton: 'btn btn-primary mr-3'
        },
        buttonsStyling: false,
        showCancelButton: false,
        onClose: () => {
          window.location.reload();
        }
      });
    } catch(ex) {
      AjaxLoader.hide();
      Swal.fire({
        html: `Infelizmente não foi possível adicionar o dependente no responsável.`,
        showClass: { backdrop: 'swal2-noanimation', popup: '', },
        hideClass: { popup: '' },
        customClass: {
          cancelButton: 'btn btn-gray-primary',
          confirmButton: 'btn btn-primary mr-3'
        },
        buttonsStyling: false,
        showCancelButton: false
      });
    }
  }

  isDependentValid() {
    return [this.selectEnrollmentTarget, this.selectKinshipTarget].reduce((accumulator, $el) => {
      let formGroup = $el.closest('.form-group'),
        label = formGroup.querySelector('label'),
        isValid = !isEmpty($el.value);
      formGroup.classList.remove('has-error');
      label.classList.remove('is-invalid');

      if (!isValid) {
        formGroup.classList.add('has-error');
        label.classList.add('is-invalid');
      }

      return accumulator &= isValid;
    }, true);
  }

  async enrollments() {
    if (!this.enrollmentStorageList || this.enrollmentStorageList.length == 0) {
      this.enrollmentStorageList = await EnrollmentService.actives();
    }

    return JSON.parse(this.enrollmentStorageList);
  }

  get enrollmentStorageList() {
    return sessionStorage.getItem('enrollments_list');
  }

  set enrollmentStorageList(list) {
    list = list.map((i) => {
      return { id: i.id, text: i.name.toUpperCase()}
    });
    list = JSON.stringify(list);
    sessionStorage.setItem('enrollments_list', list);
  }
}